<script setup lang="ts">
import { isEmpty } from 'es-toolkit/compat'
import { DIALOG_STEP_PRIORITY } from '#imports'

interface UserLoggedOutMessage {
    title: string
    description: string
}

const userLoggedOutMessage = ref<UserLoggedOutMessage | null>(null)

const checkLoggedOutByReason = () => {
    const userForcedLoggedOut = useCookie<string | null>('userForcedLoggedOut')

    if (userForcedLoggedOut.value === 'single_session_rule') {
        userLoggedOutMessage.value = {
            title: 'Du er blevet logget ud',
            description: 'Vi har registreret et login fra en anden enhed og du er derfor blevet logget ud her.'
        }
    }
}

const clearCookie = () => {
    const userForcedLoggedOut = useCookie<string | null>('userForcedLoggedOut')
    userForcedLoggedOut.value = null
}

const clearMessageAndCookie = () => {
    clearCookie()

    userLoggedOutMessage.value = null
}

onMounted(() => {
    checkLoggedOutByReason()
    clearCookie()
})

onBeforeUnmount(() => {
    clearMessageAndCookie()
})
</script>

<template>
    <UIDialogStep
        v-if="!isEmpty(userLoggedOutMessage)"
        :model-value="true"
        name="user-logged-out"
        :priority="DIALOG_STEP_PRIORITY.userLoggedOut"
        @closed="clearMessageAndCookie"
    >
        <template #default="{ close }">
            <UISheetPage
                illustration="/media/game/inspector-loop.png"
                :title="userLoggedOutMessage?.title ?? ''"
                data-test="user-logged-out-message"
            >
                <div v-text="userLoggedOutMessage?.description" />

                <template #actions>
                    <UIButton
                        size="xl"
                        as="cta"
                        block
                        @click="close()"
                    >
                        OK
                    </UIButton>
                </template>
            </UISheetPage>
        </template>
    </UIDialogStep>
</template>
